<template>
<div class="max-width-3 mx-auto px2 mb3">
    <lightbox :activateCommand="'show_shoutout_lightbox'" :deactivateCommand="'close_shoutout_lightbox'" customClass="bg-color-white">
      <sms-checker :phone_nr="phone_nr" :user_name="user_name" :dsgvo="dsgvo" :checkerParent="'shoutout'" :success="'message'"/>
    </lightbox>
    <lightbox :activateCommand="'show_message_sent_lightbox'" :deactivateCommand="'close_message_sent_lightbox'" customClass="bg-color-white">
      <h2>Deine Nachricht wurde versendet und wird gleich auf dem Messageboard auftauchen!</h2>
      <button class="btn btn-primary mt4" @click="EBusEmit('close_message_sent_lightbox')">OK!</button>
    </lightbox>
    <lightbox :activateCommand="'show_blacklist_lightbox'" :deactivateCommand="'close_blacklist_lightbox'" customClass="bg-color-white">
      <h2>Diese Handynummer wurde gesperrt und kann keine Nachrichten mehr verschicken.</h2>
      <button class="btn btn-primary mt4" @click="EBusEmit('close_blacklist_lightbox')">OK</button>
    </lightbox>
    <headline link="/" headline="Schreibe ans Messageboard!" />
    <div class="form-wrapper pt2" v-if="isTime">
      <div class="mb2">
      <textarea class="n8-textarea" v-model="msg_text" rows=5 placeholder="Was möchtest du den Leuten mitteilen?" maxlength="600" :class="{ error: not_filled_msg_text }"></textarea>
      <p class="color-gray text-right mb2" style="max-width: 400px;">{{descStrLength}} / 600</p>
      </div>
      <div class="mb3 relative">
        <!-- <h3 class="bold mb1 ml2">Handynummer</h3> -->
        <input class="n8-input" v-model="phone_nr" required :class="{ error: not_filled_phone_nr }">
         <span class="floating-label">Handynummer*</span>
      </div>
      <div class="mb2 relative">
        <input class="n8-input" v-model="user_name" required :class="{ error: not_filled_user_name }">
        <span class="floating-label">Username*</span>
      </div>
      <div class="flex align-middle mb2 mt3">
        <input class="checkbox-input mr2" type="checkbox" v-model="dsgvo">
        <label class="pointer"  :class="{ error: not_filled_dsgvo }">Ich akzeptiere die Datenschutzbedingungen*</label>
      </div>
      <div class="flex align-middle mb2 mt3">
        <input class="checkbox-input mr2" type="checkbox" v-model="receive_newsletter">
        <label class="pointer">Ja, ich möchte den SMS-Newsletter abonnieren</label>
      </div>
      <div v-if="!allIsValidated" class="error-msg mb2">Bitte fülle alle Pflichtelder aus.</div>
      <p class="p-small" style="max-width: 400px;">Mit dem Absenden erhältst du eine SMS mit dem du deine Kommentar bestätigen kannst. Es entstehen KEINE Kosten.</p>
      <div class="mt3">
      <button class="btn btn-primary" @click="validateInput()">Absenden</button>
      </div>
      <p class="mt3 color-gray max-width-2 p-small">Denke daran, nett zu Anderen zu sein. Bei Beleidigungen, diskriminierenden oder sexistischen Nachrichten wird deine Handynummer für die Nutzung der Nachtschicht-App gesperrt.</p>
    </div>
    <div v-if="!isTime">
    <p class="px4 mx1">Im Moment ist das Messageboard deaktiviert! Immer Freitags und Samstags von 18:00 Uhr bis 6:00 könnt ihr chatten.</p>
    </div>
    

</div>
</template>
<script>
import { EventBus } from '../event-bus.js';
import Headline from './Headline.vue';
import Lightbox from './GeneralLightbox.vue';
import SMSChecker from './SMSChecker.vue';

import axios from 'axios';
import { apiUrl } from '../api';

export default {
  name: "Shoutout",
  data() {
    return {
      session: {},

      msg_text: '',
      phone_nr: '',
      user_name: '',
      dsgvo: false,

      receive_newsletter: false,

      not_filled_msg_text: false,
      not_filled_phone_nr: false,
      not_filled_user_name: false,
      not_filled_dsgvo: false,

      allIsValidated: true,

      isTime: false,
    };
  },
  components: {
    'headline': Headline,
    'lightbox': Lightbox,
    'sms-checker': SMSChecker
  },
  computed: {
    descStrLength(){
      if(this.msg_text !== null){
      return this.msg_text.length;
      }
      else return 0;
    },
  },
  created(){
    EventBus.$on('sendSession_Component', (payload) => {
      console.log('Received Session from App')
      console.log(payload)
      this.session = payload.session
    });
    EventBus.$on('sendUser_Component', (payload) => {
      console.log('Received User from App')
      console.log(payload)
      this.user_name = payload.user.user_name;
      this.phone_nr = payload.user.phone_nr;
      this.dsgvo = payload.user.dsgvo;
    });
    EventBus.$on('clear_message', () => {
      this.msg_text = '';
    })
    this.calculateTime();
  },
  mounted(){
    console.log('Component Initialized, requesting Session');
    EventBus.$emit('requestSession_Component');
    EventBus.$emit('requestUser_Component');
  },
  methods: {
    calculateTime(){
      // timer for updating
      let self = this;
      let seconds = 0;

      //Initial Timecheck
      var objDate = new Date();
      var hours = objDate.getHours();
      var day = objDate.getDay();
      if(hours < 6 || hours > 17 && day == 5 || day == 6){
          self.isTime = true;
      }else{
          self.isTime = false;
      }

      function getTime() {
          seconds++; 
          if (seconds === 60) {
            var objDate = new Date();
            var hours = objDate.getHours();
            var day = objDate.getDay();
            if(hours < 6 || hours > 17 && day == 5 || day == 6){
                self.isTime = true;
            }else{
                self.isTime = false;
            }
            seconds = 0; //reset timer   
          }
        }
        setInterval(getTime, 1000); 
    },
    EBusEmit(command){
      EventBus.$emit(command)
    },
    validateInput(){
      this.allIsValidated = true;

      this.not_filled_msg_text = false;
      this.not_filled_phone_nr = false;
      this.not_filled_user_name = false;
      this.not_filled_dsgvo = false;

      if(this.msg_text == ''){
          this.allIsValidated = false;
          this.not_filled_msg_text = true;
      }
      if(this.phone_nr == ''){
          this.allIsValidated = false;
          this.not_filled_phone_nr = true;
      }
      if(this.user_name == ''){
          this.allIsValidated = false;
          this.not_filled_user_name = true;
      }
      if(this.dsgvo == false){
          this.allIsValidated = false;
          this.not_filled_dsgvo = true;
      }
      if(this.allIsValidated == true){
            //send form data
            console.log('All is validated')
            // let that = this;
            let url =  apiUrl('/public-api/set/messageboard/json');
            let data = {};
            data.message = this.msg_text;
            data.mobilephone = this.phone_nr;
            data.newsletteroptin = this.receive_newsletter;
            data.name = this.user_name;
            axios.post(url, data)
              .then(response => { 
                console.log('Response from Shoutout Call:')
                console.log(response); 
                if(response.data.isValidated == false && response.data.isBlacklisted == false){
                  console.log('User not validated. Opening SMSChecker...')
                  EventBus.$emit('sendSession_not_validated', {
                    'validation_crypt': response.data.validation_crypt,
                    'validation_id': response.data.validation_id, 
                    'validation_object': response.data.validation_object 
                  });
                  EventBus.$emit('show_shoutout_lightbox');
                }
                if(response.data.isValidated == true){
                  console.log('User is validated. Everything is fine.')
                  this.msg_text = '';
                  EventBus.$emit('show_message_sent_lightbox')
                  console.log('Shoutout Call successful Sending Validation Session to App:')
                  EventBus.$emit('send_validation', {
                    'validation_crypt': response.data.validation_crypt,
                    'validation_id': response.data.validation_id, 
                    'validation_object': response.data.validation_object 
                  });
                  console.log('Sending User to App')
                  EventBus.$emit('send_user', {
                    'user_name': this.user_name,
                    'phone_nr': this.phone_nr,
                    'dsgvo': this.dsgvo
                  });
                }
                if(response.data.isBlacklisted == true){
                  console.log('User is Blacklisted. GTFO OF HERE')
                  EventBus.$emit('show_blacklist_lightbox')
                }
              })
              .catch(function (error) {
                  console.log(error)
              });
      }
    },
  }
}
</script>
<style>

</style>
